import React from 'react';
import CustomLink from "../../components/UI/customLink/customLink";
import {useTranslation} from "react-i18next";
import OrderVisaTable from "../../components/table/order-visa-table";
import {useSelector} from "react-redux";
import { NewVisaOrderTable } from '../../components/table/NewOrderVisaTable/new-order-visa-table';

const VisaOrders = () => {
  const {t} = useTranslation();
  const user = useSelector((state) => state.user.user)

  return (
    <div className={"flex flex-col w-full pb-32"}>
      {
        (user?.role_key === "client" ||  user?.role_key === "agent" ) &&
        <div className={"my-container rounded-lg  flex justify-end items-center w-full"}>
          <div className={"w-[207px]"}>
            <CustomLink link={"/visa-orders/new-visa"} title={t("newVisa")}/>
          </div>
        </div>
      }

      <div>
        <NewVisaOrderTable/>
        {/* <OrderVisaTable/> */}
      </div>
    </div>
  );
};

export default VisaOrders;
